const base_url = "https://api.virtualprachar.com/api";
// const base_url = "http://localhost:8000/api";

export default base_url;
